import * as React from "react";
import Skeleton from "@mui/material/Skeleton";

export default function CardsSkeleton() {
  return (
    <div className="metrics-grid">
      <Skeleton
        animation="wave"
        sx={{ bgcolor: "grey.300" }}
        variant="rounded"
        width={290}
        height={120}
      />
      <Skeleton
        animation="wave"
        sx={{ bgcolor: "grey.300" }}
        variant="rounded"
        width={290}
        height={120}
      />
      <Skeleton
        animation="wave"
        sx={{ bgcolor: "grey.300" }}
        variant="rounded"
        width={290}
        height={120}
      />
      <Skeleton
        animation="wave"
        sx={{ bgcolor: "grey.300" }}
        variant="rounded"
        width={290}
        height={120}
      />
      <Skeleton
        animation="wave"
        sx={{ bgcolor: "grey.300" }}
        variant="rounded"
        width={290}
        height={120}
      />
      <Skeleton
        animation="wave"
        sx={{ bgcolor: "grey.300" }}
        variant="rounded"
        width={290}
        height={120}
      />
      <Skeleton
        animation="wave"
        sx={{ bgcolor: "grey.300" }}
        variant="rounded"
        width={290}
        height={120}
      />
      <Skeleton
        animation="wave"
        sx={{ bgcolor: "grey.300" }}
        variant="rounded"
        width={290}
        height={120}
      />
    </div>
  );
}
